import _ from '@/utils/lodash-optimized'
import React from 'react'
import './styles.scss'

import ChangeRenderer from './ChangeRenderer'

const Item = ({ item }) => (
  <div
    key={item.id}
    className='key-value'
  >
    <span className='key'>{item.title}</span>
    <ChangeRenderer
      change={item.change}
      type={item.type}
    />
  </div>
)
export class KeyValueChangesSection extends React.Component {
  renderDebug () {
    const { section } = this.props
    return <pre>{JSON.stringify(section, null, 2)}</pre>
  }

  render () {
    const { section, debug } = this.props

    if (_.isNil(section)) {
      return null
    }
    return (
      <div className='key-value-changes-section'>
        {debug ? this.renderDebug() : null}
        {section.items
          ? section.items.map((item, index) => (
            <Item
              key={index}
              item={item}
            />
          ))
          : null}
      </div>
    )
  }
}
